import { render } from "./corner-down-left.vue?vue&type=template&id=ce98ab14"
const script = {}
script.render = render

export default script